import set from "lodash/set";

const initStat = null;

// Tab-fetched slices that are not part of the loan document (see below).
const CARRIED_KEYS = ["appraisalOrders", "secondaryValuationOrders"];

const loanDrilldownReducer = (state = initStat, action) => {
  let newState = { ...state };
  switch (action.type) {
    case "SET_LOAN_DRILLDOWN": {
      const next = action.payload;
      // `appraisalOrders` is NOT part of the loan document — the Orders tab
      // fetches it separately (GET /loan-processing/{dealId}/appraisal-orders)
      // and parks it on the slice. Every full-loan refresh (comment posted,
      // doc uploaded, deal_updated broadcast, …) replaces the object and would
      // silently drop it, so carry it across when the incoming payload is the
      // SAME loan and doesn't bring its own copy.
      const sameLoan =
        next &&
        state &&
        next._id != null &&
        state._id != null &&
        String(next._id?.$oid ?? next._id) ===
          String(state._id?.$oid ?? state._id);
      // `secondaryValuationOrders` (GET /appraisal-review/{dealId}/secondary-
      // orders, the outside-party orders) is carried the same way.
      if (sameLoan) {
        const carried = {};
        CARRIED_KEYS.forEach((k) => {
          if (next[k] === undefined && state[k] !== undefined) {
            carried[k] = state[k];
          }
        });
        if (Object.keys(carried).length) return { ...next, ...carried };
      }
      return next;
    }

    case "SET_LOAN_DRILLDOWN_KEY":
      return set(newState, action.payload.key, action.payload.value);

    case "CLEAR_LOAN_DRILLDOWN":
      return initStat;

    default:
      return state;
  }
};

export default loanDrilldownReducer;
